import { createReducer, updateState } from '@angular-architects/ngrx-toolkit';
import { appActions as actions } from './app.action';
import { AppStoreState } from './app.state';

export const appReducer = createReducer<AppStoreState, typeof actions>((actions, on) => {
    on(actions.initializeTranslations, (state, { lang }) => {
        updateState(state, 'initialize Translations', { languageSelected: lang });
    });

    on(actions.setIsBusy, (state, { value }) => {
        updateState(state, 'set IsBusy', { isBusy: value });
    });

    on(actions.setTitlePage, (state, { value }) => {
        updateState(state, 'set TitlePage', { titlePage: value });
    });

    on(actions.setLanguageSelected, (state, { value }) => {
        updateState(state, 'set LanguageSelected', { languageSelected: value });
    });

    on(actions.setTranslations, (state, { value }) => {
        updateState(state, 'set Translations', { i18n: value });
    });

    on(actions.setToken, (state, { value }) => {
        updateState(state, 'set Token', { tkn: value });
    });
    on(actions.setIsVendorUser, (state, { value }) => {
        updateState(state, 'set IsVendorUser', { isVendorUser: value });
    });
    on(actions.setLocationHistory, (state, { value: { prevUrl, currentUrl } }) => {
        updateState(state, 'set LocationHistory', {
            locationHistory: { prevUrl, currentUrl },
        });
    });
    on(actions.setPrevInspectionPage, (state, { value }) => {
        updateState(state, 'set PrevInspectionPage', { prevInspectionPage: value });
    });
    //private
    on(actions.restAll, (state, { isBusy, titlePage, languageSelected, i18n, tkn }) => {
        updateState(state, 'reset All', {
            isBusy,
            titlePage,
            languageSelected,
            i18n,
            tkn,
        });
    });
});
